import {Component, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {CoreTranslationService} from '../../../../@core/services/translation.service';

import {CoreConfigService} from '../../../../@core/services/config.service';


@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
  providers: [
    TranslatePipe
  ]
})
export class TermsOfServiceComponent implements OnInit {

  public coreConfig: any;

  constructor(
    private _coreTranslationService: CoreTranslationService,
    private _coreConfigService: CoreConfigService
  ) {
    // this._coreTranslationService.translate(english, romanian);
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
      }
    };
  }

  ngOnInit(): void {
  }
}
